import React from "react";
import {
  Flex,
  Stat,
  StatHelpText,
  StatLabel,
  StatNumber,
  useColorModeValue,
} from "@chakra-ui/react";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import IconBox from "components/Icons/IconBox";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const MiniStatistics = ({ title, amount, percentage, icon, isLoading }) => {
  const iconTeal = useColorModeValue("linear-gradient(134.23deg, #071D54 14.41%, #1E3A8A 85.58%)", "linear-gradient(134.23deg, #071D54 14.41%, #1E3A8A 85.58%)");
  const textColor = useColorModeValue("gray.700", "white");

  return (
    <Card minH='83px'>
      <CardBody>
        <Flex flexDirection='row' align='center' justify='center' w='100%'>
          <Stat me='auto'>
            <StatLabel
              fontSize='sm'
              color='gray.400'
              fontWeight='bold'
              pb='.1rem'>
              {isLoading ? <Skeleton width={"145px"} /> : title}
            </StatLabel>
            <Flex>
              <StatNumber fontSize='lg' color={textColor}>
                {isLoading ? <Skeleton width={"50px"} /> : amount}
              </StatNumber>
              <StatHelpText
                alignSelf='flex-end'
                justifySelf='flex-end'
                m='0px'
                color={percentage > 0 ? "green.400" : "red.400"}
                fontWeight='bold'
                ps='3px'
                fontSize='md'>
                {isLoading ? <Skeleton width={"30px"} /> : (percentage > 0 ? `+${percentage}%` : `${percentage}%`)}
              </StatHelpText>
            </Flex>
          </Stat>
          {isLoading ? (
         <Skeleton height={"45px"} width={"45px"} borderRadius={"10px"} />
          ) : (
            <IconBox as='box' h={"45px"} w={"45px"} bg={iconTeal}>
              {icon}
            </IconBox>
          )}
        </Flex>
      </CardBody>
    </Card>
  );
};

export default MiniStatistics;
